<i18n
  src="@/i18n/template/projects/operation/views/Dashboard/CashOutMonitor/NotifyContent.json"
></i18n>
<template>
  <div class="merchant-cash-out-alert notify-content">
    <div class="notify-content__header">
      <span class="notify-content__dot" :style="dotStyle"></span>
      <span class="notify-content__title">
        {{ alertLevelName }}
      </span>
    </div>

    <div class="notify-content__body">
      <div class="notify-content__merchant">
        {{ merchantDisplay }}
      </div>
      <div class="notify-content__summary">
        {{ summaryText }}
      </div>

      <div class="notify-content__metrics">
        <div class="metric-item" v-for="item in detailItems" :key="item.label">
          <div class="metric-item__label">{{ item.label }}</div>
          <div class="metric-item__value">{{ item.value }}</div>
        </div>
      </div>

      <div class="notify-content__actions">
        <el-button
          class="notify-content__btn notify-content__btn--read"
          @click="handleRead"
        >
          {{ markText }}
        </el-button>
        <el-button
          type="primary"
          class="notify-content__btn notify-content__btn--verify"
          @click="handleVerify"
        >
          {{ checkText }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { AlertLvlCd, AlertLvlLevel_COLOR, AlertProcSts } from './const'
import router from '@/projects/operation/router'
import api from '@/api'
import { Message } from 'element-ui'
import { emitEvent, EventTypes } from '@/util/event'

export default {
  props: ['msg'],
  computed: {
    dotStyle() {
      return {
        backgroundColor:
          AlertLvlLevel_COLOR[this.msg.alertLvlCd || AlertLvlCd.Serious]
      }
    },
    markText() {
      return this.$t('MarkAsRead')
    },
    checkText() {
      return this.$t('EnterVerification')
    },
    alertLevelName() {
      return this.msg.alertLvlNm || this.$t('ContinuousEqualCashoutAlert')
    },
    merchantDisplay() {
      if (this.msg.custId) {
        return `${this.msg.custNm || '-'}（${this.msg.custId}）`
      }
      return this.msg.custNm || '-'
    },
    summaryText() {
      return this.$t('MinuteCountEqualCashoutSuspiciousSplit', {
        minute: this.msg.slideWindowMinute,
        count: this.msg.hitCnt
      })
    },
    detailItems() {
      return [
        {
          label: this.$t('AbnormalAmount'),
          value: this.$filters.money2(this.msg.riskAmt)
        },
        {
          label: this.$t('ContinuousCount'),
          value: this.msg.hitCnt
        },
        {
          label: this.$t('TimeWindow'),
          value: this.msg.slideWindowMinute + ' ' + this.$t('Minutes')
        }
      ]
    }
  },
  methods: {
    handleRead() {
      this.$emit('close')
      this.markAsRead(this.msg.alertId)
    },
    handleVerify() {
      this.$emit('close')
      router.push({
        name: 'merchant_detail',
        query: {
          id: this.msg.custId,
          tab: 'AccountHistory',
          startDt: this.$date.toBizDateTime(this.msg.triggerTime),
          custTxDscdList: '6017,030102,1001,6009,030104'
        }
      })
      this.$api.post({
        url: 'common/riskAlert/mgmt/changeAlertProcSts',
        data: {
          alertId: this.msg.alertId,
          alertProcSts: AlertProcSts.Processed
        }
      })
      emitEvent(EventTypes.CashOutMonitor_STATUS_CHANGE)
    },
    async markAsRead(alertId) {
      const res = await api.post({
        url: 'common/riskAlert/mgmt/changeAlertProcSts',
        data: {
          alertId: alertId,
          alertProcSts: AlertProcSts.Read
        }
      })
      if (res) {
        Message.success(this.$t('success'))
        emitEvent(EventTypes.CashOutMonitor_STATUS_CHANGE)
      }
    }
  }
}
</script>
<style lang="scss">
.el-notification.merchant-cash-out-alert {
  width: 450px;
  .el-notification__group {
    width: 100%;
  }
}
.merchant-cash-out-alert {
  .notify-content {
    width: 100%;
    &__header {
      display: flex;
      align-items: center;
      margin: 12px 0;
      color: $text-primary;
    }

    &__dot {
      width: 18px;
      height: 18px;
      margin-right: 8px;
      border-radius: 50%;
    }

    &__title {
      font-size: 18px;
      font-weight: bold;
    }

    &__merchant {
      font-size: 16px;
      font-weight: 500;
      color: $text-primary;
      line-height: 1.4;
    }

    &__summary {
      margin-top: 8px;
      padding-bottom: 14px;
      border-bottom: 1px dashed #e5e9f2;
      font-size: 14px;
      color: #778295;
      line-height: 1.5;
    }

    &__metrics {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 12px;
      margin-top: 16px;
    }

    &__actions {
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 12px;
      margin: 18px 0;
    }

    &__btn {
      flex: 1;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 700;

      &--read {
        color: #fff;
        border-color: #ef5350;
        background: #ef5350;
      }

      &--verify {
        background: #2f73e0;
        border-color: #2f73e0;
      }
    }
  }

  .metric-item {
    min-width: 0;

    &__label {
      font-size: 13px;
      color: #97a0ad;
    }

    &__value {
      margin-top: 8px;
      font-size: 18px;
      font-weight: 700;
      color: #2f3a4f;
      line-height: 1.2;
      word-break: break-word;
    }
  }
}
</style>
